<media-controller #mediaController id="mediaChromePlayer">
    @switch (type) {
        @case ('video') {
            <video
                #mediaEl
                slot="media"
                playsinline
                [attr.title]="title"
                [attr.src]="src"
                [attr.loop]="loop ? '' : null"
                [muted]="muted"
                [attr.autoplay]="autoplay ? '' : null"
                (ended)="onEnded()"
            ></video>
        }

        @case ('youtube') {
            <youtube-video
                #mediaEl
                slot="media"
                [attr.src]="src"
                crossorigin
                [attr.muted]="muted ? '' : null"
                [attr.autoplay]="autoplay ? '' : null"
                (ended)="onEnded()"
            ></youtube-video>
        }

        @default {
            <video
                #mediaEl
                slot="media"
                playsinline
                [attr.title]="title"
                [attr.src]="src"
                [attr.loop]="loop ? '' : null"
                [muted]="muted"
                [attr.autoplay]="autoplay ? '' : null"
                (ended)="onEnded()"
            ></video>
        }
    }

    <!-- Center play button – only if controls are enabled -->
    @if (controls) {
        <div slot="centered-chrome" class="center-controls">
            <media-play-button></media-play-button>
        </div>
    }
</media-controller>
